var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDesktopicon = function SvgDesktopicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.667 12h1c.184 0 .333.15.333.333v.334a.667.667 0 0 1-.667.666H.667A.667.667 0 0 1 0 12.667v-.334C0 12.15.15 12 .333 12h1V3.333c0-.368.299-.666.667-.666h12c.368 0 .667.298.667.666V12Zm-1.334-8H2.667v7.333h10.666V4Z",
    clipRule: "evenodd"
  })));
};
export default SvgDesktopicon;